import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import '../design/design-guidelines-styles.css';
import { BrandColorRamp, ColorRamp, ColorRampGrid } from '../../components/ColorSwatch';
export const _frontmatter = {
  "pageTitle": "Color Design Guidelines",
  "title": "Color",
  "order": 2
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageContent componentName="color" type="design_intro" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Color helps express hierarchy, establish brand presence, give meaning, and
  indicate element states.
      </LeadParagraph>
      <hr></hr>
      <h2>{`Introduction`}</h2>
      <p>{`Application of the color palette brings a unified and recognizable consistency to Cengage’s array of digital products and interfaces. We are committed to complying with the `}<a parentName="p" {...{
          "href": "https://www.w3.org/TR/WCAG/"
        }}>{`Web Content Accessibility Guidelines AA standard contrast ratios`}</a>{`.`}</p>
      <p>{`All text should be legible and meet accessibility standards. The WCAG 2.2 guidelines require a 4.5:1 color contrast between text and background for normal text, and 3:1 for large text. `}<strong parentName="p">{`At Cengage we strive to always hit 4.5:1 to avoid any possible issues or questions about whether a piece of text is accessible.`}</strong>{` Additionally, any non-text visual information provided that is necessary for a user to identify that a control is present and how to operate it must have a minimum 3:1 contrast ratio with the adjacent colors.`}</p>
      <h2>{`Color Primitives`}</h2>
      <ColorRampGrid mdxType="ColorRampGrid">
  <BrandColorRamp mdxType="BrandColorRamp" />
  <ColorRamp colorPrefix="cyan" name="Cyan" shades={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="blue" name="Blue" shades={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="green" name="Green" shades={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="red" name="Red" shades={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="tangerine" name="Tangerine" shades={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="yellow" name="Yellow" shades={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="indigo" name="Indigo" shades={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="teal" name="Teal" shades={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="violet" name="Violet" shades={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="purple" name="Purple" shades={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="neutral" name="Neutral" shades={[0, 100, 150, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1150, 1200]} mdxType="ColorRamp" />
      </ColorRampGrid>
      <h2>{`Data Visualization`}</h2>
      <p>{`Data visualization colors are intended for charts, tags, and other categorical color uses. These colors should be used for distinction across data series, not to communicate semantic states like success, warning, or danger.`}</p>
      <ColorRampGrid mdxType="ColorRampGrid">
  <ColorRamp colorPrefix="dataVizBlue" name="Blue" shades={[200, 400, 500, 700]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="dataVizPink" name="Pink" shades={[200, 400, 500, 700]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="dataVizGreen" name="Green" shades={[200, 400, 500, 700]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="dataVizOrange" name="Orange" shades={[200, 400, 500, 700]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="dataVizPurple" name="Purple" shades={[200, 400, 500, 700]} mdxType="ColorRamp" />
  <ColorRamp colorPrefix="dataVizTeal" name="Teal" shades={[200, 400, 500, 700]} mdxType="ColorRamp" />
      </ColorRampGrid>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      